import React from 'react'
import { Form, Checkbox, Tooltip } from 'antd'
import styled from 'styled-components'
import { t } from '@/i18n'
import { VALIDATION_MODES } from '../../utils/constants'
import { IconFont } from '@/components'

const ValidationModeSelector: React.FC<{
  onModeChange?: (checkedValues: string[], prevValues: string[]) => void
  prevValues: string[]
}> = ({ onModeChange, prevValues }) => (
  <Wrapper>
    <div className="section-title">
      {t('任务验证配置')}
      <div className="section-bar" />
    </div>
    <div className="form-content">
      <Form.Item
        label={t('验证模式')}
        name="validationMode"
        rules={[{ required: true, message: t('请选择验证模式') }]}
        required
        initialValue={['agentToContainer']}
      >
        <Checkbox.Group
          onChange={checkedValues => {
            onModeChange?.(checkedValues as string[], prevValues)
          }}
        >
          {VALIDATION_MODES.map(mode => (
            <Checkbox key={mode.value} value={mode.value}>
              {mode.label}
              <Tooltip title={mode.help}>
                <IconFont type="icon-icon_help" className="help-icon" />
              </Tooltip>
            </Checkbox>
          ))}
        </Checkbox.Group>
      </Form.Item>
    </div>
  </Wrapper>
)

export default ValidationModeSelector

const Wrapper = styled.div`
  margin-bottom: 16px;

  .section-title {
    font-weight: 500;
    color: #1d2129;
    position: relative;

    &::after {
      content: '';
      display: block;
      position: absolute;
      left: 0;
      bottom: 0;
      width: 88px;
      height: 6px;
      background: linear-gradient(90deg, #2090a8 0%, #4238c9 100%);
      border-radius: 0px 86px 0px 100px;
      margin-top: 8px;
    }

    .section-bar {
      content: '';
      display: block;
      width: 100%;
      height: 4px;
      background: #ebeaf9;
      margin-top: 4px;
      margin-bottom: 20px;
    }
  }

  .form-content {
    padding-left: 34px;

    .ant-checkbox-wrapper {
      margin-right: 135px;
    }

    .help-icon {
      margin-left: 4px;
      color: #999;
      font-size: 16;
      cursor: 'pointer';
    }
  }
`
